/**
 * Le Journal — améliorations progressives de la page article.
 * Tout le contenu (sommaire, CTA, liens) est rendu côté serveur : ce script
 * n'ajoute que du confort et la page reste complète sans JavaScript.
 *  - barre de progression de lecture
 *  - lien actif du sommaire
 *  - copie du lien de l'article
 *  - barre produit mobile (affichée après le début de lecture, masquée en fin d'article)
 */

const article = document.querySelector('[data-journal-article]');

if (article) {
  const body = article.querySelector('[data-journal-body]');
  const progressBar = document.querySelector('.journal-progress__bar');
  const mobileBar = document.querySelector('[data-journal-mobile-bar]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Progression + barre mobile */
  let ticking = false;

  const update = () => {
    ticking = false;
    if (!body) return;

    const rect = body.getBoundingClientRect();
    const total = rect.height - window.innerHeight * 0.5;
    const read = Math.min(Math.max(-rect.top + window.innerHeight * 0.25, 0), Math.max(total, 1));
    const ratio = total > 0 ? read / total : 0;

    if (progressBar) progressBar.style.transform = `scaleX(${ratio})`;

    if (mobileBar) {
      const started = rect.top < window.innerHeight * 0.2;
      const finished = rect.bottom < window.innerHeight;
      mobileBar.hidden = !(started && !finished);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  if (progressBar || mobileBar) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* Lien actif du sommaire */
  const tocLinks = Array.from(document.querySelectorAll('.journal-toc a[href^="#"]'));

  if (body && tocLinks.length && 'IntersectionObserver' in window) {
    const headings = Array.from(body.querySelectorAll('h2[id]'));

    const setActive = (id) => {
      tocLinks.forEach((link) => {
        if (decodeURIComponent(link.hash.slice(1)) === id) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length) setActive(visible[0].target.id);
      },
      { rootMargin: '0px 0px -70% 0px', threshold: 0 }
    );

    headings.forEach((heading) => observer.observe(heading));
  }

  /* Sommaire mobile : se replie après un clic */
  document.querySelectorAll('.journal-toc--mobile a').forEach((link) => {
    link.addEventListener('click', () => {
      const details = link.closest('details');
      if (details) details.open = false;
    });
  });

  /* Défilement doux vers les ancres (respecte « réduire les animations ») */
  if (!reduceMotion) {
    tocLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', link.hash);
      });
    });
  }

  /* Copier le lien */
  const copyButton = article.querySelector('[data-journal-copy]');
  const copyStatus = article.querySelector('[data-journal-copy-status]');

  if (copyButton && navigator.clipboard && window.isSecureContext) {
    copyButton.hidden = false;
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(copyButton.dataset.journalCopy || window.location.href);
        const message = copyButton.dataset.journalCopied || '';
        if (copyStatus) copyStatus.textContent = message;
        copyButton.setAttribute('data-copied', 'true');
        window.setTimeout(() => copyButton.removeAttribute('data-copied'), 2000);
      } catch (error) {
        // Presse-papiers refusé : on ne fait rien, le lien reste dans la barre d'adresse.
      }
    });
  }
}
